import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

Vue.use(VueRouter)

import Login from '../views/auth/Login'
import UserList from '../views/user/UserList'
import UserView from '../views/user/UserView'
import StationList from '../views/station/StationList'
import StationView from '../views/station/StationView'
import StationMeasurement from '../views/station/StationMeasurement'
import SoilTypeList from '../views/soil-type/SoilTypeList'
import SoilTypeView from '../views/soil-type/SoilTypeView'
import RecommendationTableView from '../views/rec-table/RecTableView'
import CultureTableView from '../views/culture-table/CultureTableView'
import CultureGrowthPhaseView from '../views/culture-growth-phase/CultureGrowthPhaseView'
import CultureGrowthPhaseItemsView from '../views/culture-growth-phase/CultureGrowthPhaseItemsView'
import CalculationTableView from '../views/calculations/recommendations/CalculationTableView'
import DataAnalytics from '@/views/analytics/DataAnalytics'
import UserPermissions from '@/views/user-permissions/UserPermissions'
import MapFormulaView from '@/views/calculations/map-formulas/MapFormulaView'
import No3FormulaView from '@/views/calculations/no3-formulas/No3FormulaView'
import DashboardFormulaView from '@/views/calculations/dashboard-formulas/DashboardFormulaView'
import StationErrorList from '@/views/station-error/StationErrorList'
import StationErrorHistory from '@/views/station-error/StationErrorHistory'
import StationMessageView from '@/views/station-message/StationMessageView'
import AnnualSummaryLayout from '@/views/annual-summary/AnnualSummaryLayout.vue'
import StationLocationView from '@/views/station-location/StationLocationView.vue'
import FieldsLayout from '@/views/reports/field-connections/FieldsLayout.vue'
import StationsLayout from '@/views/reports/stations/StationsLayout.vue'
import PercoInfoView from '@/views/perco-info/PercoInfoView.vue'
import CompaniesLayout from '@/views/companies/CompaniesLayout.vue';
import CompaniesList from '@/components/companies/CompaniesList.vue';
import CompaniesView from '@/views/companies/CompaniesView.vue';

const routes = [
    { name: 'login', path: '/login', component: Login },
    { name: 'user-list', path: '/user', component: UserList },
    { name: 'user-view', path: '/user/:id', component: UserView },
    { name: 'station-list', path: '/station', component: StationList },
    { name: 'station-view', path: '/station/:id', component: StationView },
    { name: 'station-measurement', path: '/station/:id/measurement', component: StationMeasurement },
    { name: 'soil-type-list', path: '/soil-type', component: SoilTypeList },
    { name: 'soil-type-view', path: '/soil-type/:id', component: SoilTypeView },
    { name: 'recommendation-table-view', path: '/recommendation-table', component: RecommendationTableView },
    { name: 'culture-table-view', path: '/culture-table', component: CultureTableView },
    { name: 'culture-growth-phase', path: '/culture-growth-phase', component: CultureGrowthPhaseView },
    { name: 'culture-growth-phase-items', path: '/culture-growth-phase/:phaseId/items', component: CultureGrowthPhaseItemsView },
    { name: 'calculation-table-view', path: '/calculation-table', component: CalculationTableView },
    { name: 'map-formula-view', path: '/map-formulas', component: MapFormulaView },
    { name: 'no3-formula-view', path: '/no3-formulas', component: No3FormulaView },
    { name: 'dashboard-formula-view', path: '/dashboard-formulas', component: DashboardFormulaView },
    { name: 'data-analytics-view', path: '/data-analytics', component: DataAnalytics },
    { name: 'user-permissions-view', path: '/user-permissions', component: UserPermissions },
    { name: 'station-error-view', path: '/station-error', component: StationErrorList },
    { name: 'station-error-history-view', path: '/station-error-history', component: StationErrorHistory },
    { name: 'station-message-view', path: '/station-message', component: StationMessageView },
    { name: 'annual-summary', path: '/annual-summary', component: AnnualSummaryLayout },
    { name: 'station-location', path: '/station/:probeId/location/:locationId', component: StationLocationView },
    { name: 'report-fields', path: '/report/fields', component: FieldsLayout },
    { name: 'report-stations', path: '/report/stations', component: StationsLayout },
    { name: 'perco-info', path: '/perco-info', component: PercoInfoView },
    { name: 'companies', path: '/companies', component: CompaniesLayout, children: [
        { name: 'company-list', path: '', component: CompaniesList },
        { name: 'company-edit', path: '/:id/edit', component: CompaniesList },
        { name: 'company-view', path: ':id', component: CompaniesView },
    ]},
]

const router = new VueRouter({
    routes,
    mode: 'history',
})

router.beforeEach((to, from, next) => {
    store.dispatch('app/cancelPendingRequests')
    const publicPages = ['/login']
    const authRequired = !publicPages.includes(to.path)
    const loggedIn = localStorage.getItem('pt_user')

    if (publicPages.includes(to.path)) {
        store.state.auth.user = false
    }

    if (to.path === '/') {
        next('/user')
    }

    if (loggedIn && !authRequired) {
        next('/user')
    }

    if (authRequired && !loggedIn) {
        next('/login')
    } else {
        next()
    }
})

export default router
